
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index7_4576so8QCncfVlxl6ul7KXKsUfCh8sg4Xfo7kidN8TkMeta } from "/builds/sbt/smsbat/pages/index.vue?macro=true";
import { default as indexEgVozXO2t9zxh6yEXLQV_451ZNzJ9VY9qMaHDmJmw7e8gMeta } from "/builds/sbt/smsbat/pages/chat/index.vue?macro=true";
import { default as indexct1qiHXjNyymHB8yn74pmyqqEpw25GGckrpNZeaBeJYMeta } from "/builds/sbt/smsbat/pages/dmca/index.vue?macro=true";
import { default as indexYI4oRTrwkR7lo4wTSN5EL0NRVW18MBBplTwysYA4_455YMeta } from "/builds/sbt/smsbat/pages/about/index.vue?macro=true";
import { default as indexHHxkoyrjFG_9fAoSlNwHeR9kWFx6ckNkffsEYgJnsboMeta } from "/builds/sbt/smsbat/pages/viber/index.vue?macro=true";
import { default as indexP_1d81LWjW0rhnkE4pSQlJqABGDPlNDOyGCW_45PQdIM0Meta } from "/builds/sbt/smsbat/pages/chathub/index.vue?macro=true";
import { default as index0D0SiCIHG4a0m3gbR1UsuGH7WpXu2QNwMB_roXiPDk8Meta } from "/builds/sbt/smsbat/pages/pricing/index.vue?macro=true";
import { default as indexR_1AYY_j7IQF49Q_45mwzbyhKkitpOaUCaPcEaiFaOLB8Meta } from "/builds/sbt/smsbat/pages/privacy/index.vue?macro=true";
import { default as indexi1zPU8XuYEx8q6aQiHpSFx5SFo0_45JLp6WE90vEW3ZqEMeta } from "/builds/sbt/smsbat/pages/contacts/index.vue?macro=true";
import { default as indexNfUc68Vhz5BZPRzIM2EXDMWP6clsS2XTnTFuqZeDMN8Meta } from "/builds/sbt/smsbat/pages/services/index.vue?macro=true";
import { default as index84onD8POcPeQsSN9L9p5XrJSy1itQqmFx4VAlX8xl6kMeta } from "/builds/sbt/smsbat/pages/use-terms/index.vue?macro=true";
import { default as indexk0LlMMA21wrhftQI8H_QY39cH7bpfdIz_45UfmmkzgO5oMeta } from "/builds/sbt/smsbat/pages/viber-otp/index.vue?macro=true";
import { default as indexcfZlPxEZf2iqwRwQRXUZtxCmo4xgF7NS4f5PObrwvvAMeta } from "/builds/sbt/smsbat/pages/partnership/index.vue?macro=true";
import { default as indexMUMmzJcUtVyWYdaO7KZ3QOhnp7ZcUgR1b5A__fYkvFcMeta } from "/builds/sbt/smsbat/pages/sms-gateway/index.vue?macro=true";
import { default as index_bLrU5JK6bu6FoOCe2pvRoPwmvmaYxttaZseYV08iMoMeta } from "/builds/sbt/smsbat/pages/certificates/index.vue?macro=true";
import { default as indexgHRdOBGoVQtCTD3f7_0qrsPp_45E0wbzBbhP_pc6rVqzYMeta } from "/builds/sbt/smsbat/pages/register-bot/index.vue?macro=true";
import { default as indexeFklciciXhyuGFeYfY_45waT4L3vLbIcdwAIoIcw_XIN0Meta } from "/builds/sbt/smsbat/pages/viber-survey/index.vue?macro=true";
import { default as indexagIVILBA60xlSNg48Ice_aiNjcRRaZy5_7jLpdmA_MgMeta } from "/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue?macro=true";
import { default as indexr4XDxcBOtsN_grjQ0NDQT_45nwFTacEr0EZ8pWXeAmwVEMeta } from "/builds/sbt/smsbat/pages/sms-marketing/index.vue?macro=true";
import { default as index7D_Us4ZTbncbHr6swqbkoG4Qai8gih1PKgq3FhDSngkMeta } from "/builds/sbt/smsbat/pages/viber-carousel/index.vue?macro=true";
import { default as index_45NRwj26rloKYTmuuj8ekwsobGhd3RLLlTFFRIW0CXPAMeta } from "/builds/sbt/smsbat/pages/viber-chatbots/index.vue?macro=true";
import { default as indextAnvK_45uKisz90Fo0kG9N0r6AeNTxwB9jQG2sIS1KfHgMeta } from "/builds/sbt/smsbat/pages/session-counter/index.vue?macro=true";
import { default as index6uELjWJyuR4vV4P_utfsz6UnQA1rsnFjzOKK3vs_457pUMeta } from "/builds/sbt/smsbat/pages/bots-constructor/index.vue?macro=true";
import { default as indexapWtJGnS8JjJjHBjRs_oAqkRJvsw06ld52DsjFxyLS4Meta } from "/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue?macro=true";
import { default as indexti9lQep5P4_Qy1pYteFZOw_45nDB4TQSaiBy9Ez_sXD9wMeta } from "/builds/sbt/smsbat/pages/how-it-works/sms/index.vue?macro=true";
import { default as indexIf7fl6vRiBK8afG5_CvoI_45nXqbu3qaHPst7SFiM6z9gMeta } from "/builds/sbt/smsbat/pages/pricing/[channel]/index.vue?macro=true";
import { default as indexNPONW9WHmOyJQS5abC9kQY1dDsydEk2mzS2qdw8AhisMeta } from "/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue?macro=true";
import { default as index4iQpHiTp_njHzsSEYSoFhV0fthq63OfviDxA5ZUAyT0Meta } from "/builds/sbt/smsbat/pages/how-it-works/viber/index.vue?macro=true";
import { default as indexl5ZAqdIj4XRQdF1XnUPyMEUCObfNfQTtFjzi9ZaMFhkMeta } from "/builds/sbt/smsbat/pages/viber-bot-provider/index.vue?macro=true";
import { default as indexwlGlrCVPRq8iWh6jzdglq2s0LY_4586zuQOMDAnoYF4CgMeta } from "/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue?macro=true";
import { default as indexXzs66IU3PV1D9ywQTii_KdSldIBjHfJzZMGxdon1F3EMeta } from "/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue?macro=true";
import { default as indexENUebbwJaoagERdOKiyo4AXy7wEklrUY305kDUZV_450cMeta } from "/builds/sbt/smsbat/pages/viber-business-calls/index.vue?macro=true";
import { default as indexdMuPstddZb9vOVjMwqeVZRquao1ohAJB1tfxSxAjOh0Meta } from "/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue?macro=true";
import { default as indexfAUgSM_456ea5E4mlRjg2bG0sIMWtnIE_45Pi6AFF_45hlTSoMeta } from "/builds/sbt/smsbat/pages/viber-bot-registration/index.vue?macro=true";
import { default as indexzXMH3IGCw8Vh9Lzs3VDrOfLCh2BfCYHFsHK66pX9ascMeta } from "/builds/sbt/smsbat/pages/viber-bot-verification/index.vue?macro=true";
import { default as indexClx3ZOvfUq54DaI1_45lZD_4582u1dr4nd1eI_pcNd6jqL8Meta } from "/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue?macro=true";
import { default as indexTW0fB_45VXUO7XLAh3JV345v_457BmxQPXEGGl7fdWPFp9gMeta } from "/builds/sbt/smsbat/pages/viber-business-messages/index.vue?macro=true";
import { default as indextDr8JcJFeFe8t96YNr3zZtOCr209_zVhuhwvT7FTjP4Meta } from "/builds/sbt/smsbat/pages/two-factor-authentication/index.vue?macro=true";
import { default as indexIeQh3rYwEj92XP_45WxBzQfm19mVyPyI_45fMJVRARgAywUMeta } from "/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue?macro=true";
import { default as indexjNHu9EcU54hKwHa9EVw33butVIdFTgGLwEnD7ZGH9I8Meta } from "/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue?macro=true";
import { default as indexhO8yUvLq1GUjwmCBF9XlGlfG9WN2WYeU5cLXfG1h80MMeta } from "/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue?macro=true";
import { default as indexSM_WyldGh4pJK27CFd2XB7zX2TaoH57ucQvwsSaTDjgMeta } from "/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue?macro=true";
import { default as indexo2kk6jGCQxIyQ2gG9ACZXsNxnBQoqepaAIo56CwVPIwMeta } from "/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue?macro=true";
import { default as index6yYAv68ddS5jpL_45YXNwwwBNhb5ja3TMOC_bh_qlhj6oMeta } from "/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue?macro=true";
import { default as component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqowMeta } from "/builds/sbt/smsbat/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqow } from "/builds/sbt/smsbat/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en-us",
    path: "/",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___uk-ua",
    path: "/uk-ua",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___bg",
    path: "/bg",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___hr",
    path: "/hr",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___da",
    path: "/da",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___et",
    path: "/et",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___fi",
    path: "/fi",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___el",
    path: "/el",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___hu",
    path: "/hu",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___ga",
    path: "/ga",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___lv",
    path: "/lv",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___lt",
    path: "/lt",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___mt",
    path: "/mt",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___sk",
    path: "/sk",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___sl",
    path: "/sl",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___sv",
    path: "/sv",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___my",
    path: "/my",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___fil",
    path: "/fil",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___ro-md",
    path: "/ro-md",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___dv",
    path: "/dv",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___hy",
    path: "/hy",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___sq",
    path: "/sq",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___bs",
    path: "/bs",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___sr",
    path: "/sr",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___ka",
    path: "/ka",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___ne",
    path: "/ne",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___vi",
    path: "/vi",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "index___he",
    path: "/he",
    component: () => import("/builds/sbt/smsbat/pages/index.vue")
  },
  {
    name: "chat___en-us",
    path: "/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___uk-ua",
    path: "/uk-ua/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___bg",
    path: "/bg/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___hr",
    path: "/hr/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___cs",
    path: "/cs/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___da",
    path: "/da/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___nl",
    path: "/nl/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___et",
    path: "/et/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___fi",
    path: "/fi/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___fr",
    path: "/fr/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___de",
    path: "/de/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___el",
    path: "/el/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___hu",
    path: "/hu/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___ga",
    path: "/ga/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___it",
    path: "/it/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___lv",
    path: "/lv/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___lt",
    path: "/lt/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___mt",
    path: "/mt/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___pl",
    path: "/pl/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___pt",
    path: "/pt/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___ro",
    path: "/ro/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___sk",
    path: "/sk/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___sl",
    path: "/sl/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___es",
    path: "/es/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___sv",
    path: "/sv/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___tr",
    path: "/tr/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___my",
    path: "/my/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___fil",
    path: "/fil/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___ro-md",
    path: "/ro-md/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___dv",
    path: "/dv/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___hy",
    path: "/hy/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___sq",
    path: "/sq/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___bs",
    path: "/bs/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___sr",
    path: "/sr/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___ka",
    path: "/ka/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___ne",
    path: "/ne/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___vi",
    path: "/vi/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___ko",
    path: "/ko/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "chat___he",
    path: "/he/chat",
    component: () => import("/builds/sbt/smsbat/pages/chat/index.vue")
  },
  {
    name: "dmca___en-us",
    path: "/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___uk-ua",
    path: "/uk-ua/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___bg",
    path: "/bg/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___hr",
    path: "/hr/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___cs",
    path: "/cs/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___da",
    path: "/da/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___nl",
    path: "/nl/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___et",
    path: "/et/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___fi",
    path: "/fi/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___fr",
    path: "/fr/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___de",
    path: "/de/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___el",
    path: "/el/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___hu",
    path: "/hu/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___ga",
    path: "/ga/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___it",
    path: "/it/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___lv",
    path: "/lv/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___lt",
    path: "/lt/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___mt",
    path: "/mt/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___pl",
    path: "/pl/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___pt",
    path: "/pt/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___ro",
    path: "/ro/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___sk",
    path: "/sk/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___sl",
    path: "/sl/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___es",
    path: "/es/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___sv",
    path: "/sv/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___tr",
    path: "/tr/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___my",
    path: "/my/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___fil",
    path: "/fil/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___ro-md",
    path: "/ro-md/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___dv",
    path: "/dv/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___hy",
    path: "/hy/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___sq",
    path: "/sq/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___bs",
    path: "/bs/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___sr",
    path: "/sr/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___ka",
    path: "/ka/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___ne",
    path: "/ne/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___vi",
    path: "/vi/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___ko",
    path: "/ko/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "dmca___he",
    path: "/he/dmca",
    component: () => import("/builds/sbt/smsbat/pages/dmca/index.vue")
  },
  {
    name: "about___en-us",
    path: "/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___uk-ua",
    path: "/uk-ua/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___bg",
    path: "/bg/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___hr",
    path: "/hr/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___cs",
    path: "/cs/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___da",
    path: "/da/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___nl",
    path: "/nl/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___et",
    path: "/et/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___fi",
    path: "/fi/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___fr",
    path: "/fr/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___de",
    path: "/de/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___el",
    path: "/el/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___hu",
    path: "/hu/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___ga",
    path: "/ga/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___it",
    path: "/it/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___lv",
    path: "/lv/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___lt",
    path: "/lt/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___mt",
    path: "/mt/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___pt",
    path: "/pt/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___ro",
    path: "/ro/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___sk",
    path: "/sk/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___sl",
    path: "/sl/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___es",
    path: "/es/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___sv",
    path: "/sv/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___tr",
    path: "/tr/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___my",
    path: "/my/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___fil",
    path: "/fil/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___ro-md",
    path: "/ro-md/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___dv",
    path: "/dv/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___hy",
    path: "/hy/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___sq",
    path: "/sq/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___bs",
    path: "/bs/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___sr",
    path: "/sr/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___ka",
    path: "/ka/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___ne",
    path: "/ne/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___vi",
    path: "/vi/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___ko",
    path: "/ko/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "about___he",
    path: "/he/about",
    component: () => import("/builds/sbt/smsbat/pages/about/index.vue")
  },
  {
    name: "viber___en-us",
    path: "/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___uk-ua",
    path: "/uk-ua/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___bg",
    path: "/bg/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___hr",
    path: "/hr/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___cs",
    path: "/cs/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___da",
    path: "/da/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___nl",
    path: "/nl/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___et",
    path: "/et/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___fi",
    path: "/fi/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___fr",
    path: "/fr/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___de",
    path: "/de/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___el",
    path: "/el/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___hu",
    path: "/hu/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___ga",
    path: "/ga/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___it",
    path: "/it/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___lv",
    path: "/lv/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___lt",
    path: "/lt/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___mt",
    path: "/mt/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___pl",
    path: "/pl/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___pt",
    path: "/pt/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___ro",
    path: "/ro/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___sk",
    path: "/sk/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___sl",
    path: "/sl/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___es",
    path: "/es/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___sv",
    path: "/sv/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___tr",
    path: "/tr/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___my",
    path: "/my/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___fil",
    path: "/fil/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___ro-md",
    path: "/ro-md/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___dv",
    path: "/dv/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___hy",
    path: "/hy/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___sq",
    path: "/sq/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___bs",
    path: "/bs/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___sr",
    path: "/sr/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___ka",
    path: "/ka/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___ne",
    path: "/ne/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___vi",
    path: "/vi/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___ko",
    path: "/ko/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "viber___he",
    path: "/he/viber",
    component: () => import("/builds/sbt/smsbat/pages/viber/index.vue")
  },
  {
    name: "chathub___en-us",
    path: "/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___uk-ua",
    path: "/uk-ua/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___bg",
    path: "/bg/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___hr",
    path: "/hr/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___cs",
    path: "/cs/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___da",
    path: "/da/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___nl",
    path: "/nl/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___et",
    path: "/et/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___fi",
    path: "/fi/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___fr",
    path: "/fr/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___de",
    path: "/de/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___el",
    path: "/el/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___hu",
    path: "/hu/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___ga",
    path: "/ga/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___it",
    path: "/it/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___lv",
    path: "/lv/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___lt",
    path: "/lt/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___mt",
    path: "/mt/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___pl",
    path: "/pl/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___pt",
    path: "/pt/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___ro",
    path: "/ro/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___sk",
    path: "/sk/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___sl",
    path: "/sl/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___es",
    path: "/es/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___sv",
    path: "/sv/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___tr",
    path: "/tr/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___my",
    path: "/my/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___fil",
    path: "/fil/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___ro-md",
    path: "/ro-md/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___dv",
    path: "/dv/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___hy",
    path: "/hy/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___sq",
    path: "/sq/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___bs",
    path: "/bs/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___sr",
    path: "/sr/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___ka",
    path: "/ka/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___ne",
    path: "/ne/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___vi",
    path: "/vi/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___ko",
    path: "/ko/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "chathub___he",
    path: "/he/chathub",
    component: () => import("/builds/sbt/smsbat/pages/chathub/index.vue")
  },
  {
    name: "pricing___en-us",
    path: "/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___uk-ua",
    path: "/uk-ua/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___bg",
    path: "/bg/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___hr",
    path: "/hr/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___cs",
    path: "/cs/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___da",
    path: "/da/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___nl",
    path: "/nl/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___et",
    path: "/et/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___fi",
    path: "/fi/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___fr",
    path: "/fr/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___de",
    path: "/de/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___el",
    path: "/el/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___hu",
    path: "/hu/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___ga",
    path: "/ga/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___it",
    path: "/it/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___lv",
    path: "/lv/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___lt",
    path: "/lt/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___mt",
    path: "/mt/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___pl",
    path: "/pl/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___pt",
    path: "/pt/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___ro",
    path: "/ro/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___sk",
    path: "/sk/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___sl",
    path: "/sl/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___es",
    path: "/es/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___sv",
    path: "/sv/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___tr",
    path: "/tr/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___my",
    path: "/my/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___fil",
    path: "/fil/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___ro-md",
    path: "/ro-md/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___dv",
    path: "/dv/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___hy",
    path: "/hy/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___sq",
    path: "/sq/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___bs",
    path: "/bs/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___sr",
    path: "/sr/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___ka",
    path: "/ka/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___ne",
    path: "/ne/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___vi",
    path: "/vi/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___ko",
    path: "/ko/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "pricing___he",
    path: "/he/pricing",
    component: () => import("/builds/sbt/smsbat/pages/pricing/index.vue")
  },
  {
    name: "privacy___en-us",
    path: "/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___uk-ua",
    path: "/uk-ua/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___bg",
    path: "/bg/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___hr",
    path: "/hr/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___cs",
    path: "/cs/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___da",
    path: "/da/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___nl",
    path: "/nl/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___et",
    path: "/et/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___fi",
    path: "/fi/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___fr",
    path: "/fr/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___de",
    path: "/de/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___el",
    path: "/el/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___hu",
    path: "/hu/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___ga",
    path: "/ga/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___it",
    path: "/it/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___lv",
    path: "/lv/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___lt",
    path: "/lt/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___mt",
    path: "/mt/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___pt",
    path: "/pt/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___ro",
    path: "/ro/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___sk",
    path: "/sk/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___sl",
    path: "/sl/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___es",
    path: "/es/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___sv",
    path: "/sv/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___tr",
    path: "/tr/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___my",
    path: "/my/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___fil",
    path: "/fil/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___ro-md",
    path: "/ro-md/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___dv",
    path: "/dv/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___hy",
    path: "/hy/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___sq",
    path: "/sq/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___bs",
    path: "/bs/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___sr",
    path: "/sr/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___ka",
    path: "/ka/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___ne",
    path: "/ne/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___vi",
    path: "/vi/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___ko",
    path: "/ko/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "privacy___he",
    path: "/he/privacy",
    component: () => import("/builds/sbt/smsbat/pages/privacy/index.vue")
  },
  {
    name: "contacts___en-us",
    path: "/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___uk-ua",
    path: "/uk-ua/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___bg",
    path: "/bg/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___hr",
    path: "/hr/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___cs",
    path: "/cs/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___da",
    path: "/da/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___nl",
    path: "/nl/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___et",
    path: "/et/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___fi",
    path: "/fi/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___fr",
    path: "/fr/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___de",
    path: "/de/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___el",
    path: "/el/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___hu",
    path: "/hu/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___ga",
    path: "/ga/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___it",
    path: "/it/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___lv",
    path: "/lv/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___lt",
    path: "/lt/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___mt",
    path: "/mt/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___pl",
    path: "/pl/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___pt",
    path: "/pt/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___ro",
    path: "/ro/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___sk",
    path: "/sk/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___sl",
    path: "/sl/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___es",
    path: "/es/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___sv",
    path: "/sv/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___tr",
    path: "/tr/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___my",
    path: "/my/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___fil",
    path: "/fil/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___ro-md",
    path: "/ro-md/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___dv",
    path: "/dv/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___hy",
    path: "/hy/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___sq",
    path: "/sq/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___bs",
    path: "/bs/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___sr",
    path: "/sr/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___ka",
    path: "/ka/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___ne",
    path: "/ne/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___vi",
    path: "/vi/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___ko",
    path: "/ko/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "contacts___he",
    path: "/he/contacts",
    component: () => import("/builds/sbt/smsbat/pages/contacts/index.vue")
  },
  {
    name: "services___en-us",
    path: "/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___uk-ua",
    path: "/uk-ua/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___bg",
    path: "/bg/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___hr",
    path: "/hr/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___cs",
    path: "/cs/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___da",
    path: "/da/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___nl",
    path: "/nl/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___et",
    path: "/et/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___fi",
    path: "/fi/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___fr",
    path: "/fr/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___de",
    path: "/de/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___el",
    path: "/el/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___hu",
    path: "/hu/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___ga",
    path: "/ga/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___it",
    path: "/it/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___lv",
    path: "/lv/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___lt",
    path: "/lt/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___mt",
    path: "/mt/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___pl",
    path: "/pl/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___pt",
    path: "/pt/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___ro",
    path: "/ro/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___sk",
    path: "/sk/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___sl",
    path: "/sl/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___es",
    path: "/es/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___sv",
    path: "/sv/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___tr",
    path: "/tr/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___my",
    path: "/my/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___fil",
    path: "/fil/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___ro-md",
    path: "/ro-md/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___dv",
    path: "/dv/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___hy",
    path: "/hy/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___sq",
    path: "/sq/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___bs",
    path: "/bs/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___sr",
    path: "/sr/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___ka",
    path: "/ka/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___ne",
    path: "/ne/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___vi",
    path: "/vi/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___ko",
    path: "/ko/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "services___he",
    path: "/he/services",
    component: () => import("/builds/sbt/smsbat/pages/services/index.vue")
  },
  {
    name: "use-terms___en-us",
    path: "/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___uk-ua",
    path: "/uk-ua/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___bg",
    path: "/bg/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___hr",
    path: "/hr/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___cs",
    path: "/cs/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___da",
    path: "/da/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___nl",
    path: "/nl/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___et",
    path: "/et/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___fi",
    path: "/fi/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___fr",
    path: "/fr/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___de",
    path: "/de/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___el",
    path: "/el/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___hu",
    path: "/hu/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___ga",
    path: "/ga/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___it",
    path: "/it/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___lv",
    path: "/lv/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___lt",
    path: "/lt/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___mt",
    path: "/mt/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___pl",
    path: "/pl/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___pt",
    path: "/pt/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___ro",
    path: "/ro/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___sk",
    path: "/sk/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___sl",
    path: "/sl/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___es",
    path: "/es/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___sv",
    path: "/sv/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___tr",
    path: "/tr/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___my",
    path: "/my/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___fil",
    path: "/fil/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___ro-md",
    path: "/ro-md/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___dv",
    path: "/dv/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___hy",
    path: "/hy/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___sq",
    path: "/sq/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___bs",
    path: "/bs/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___sr",
    path: "/sr/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___ka",
    path: "/ka/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___ne",
    path: "/ne/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___vi",
    path: "/vi/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___ko",
    path: "/ko/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "use-terms___he",
    path: "/he/use-terms",
    component: () => import("/builds/sbt/smsbat/pages/use-terms/index.vue")
  },
  {
    name: "viber-otp___en-us",
    path: "/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___uk-ua",
    path: "/uk-ua/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___bg",
    path: "/bg/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___hr",
    path: "/hr/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___cs",
    path: "/cs/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___da",
    path: "/da/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___nl",
    path: "/nl/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___et",
    path: "/et/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___fi",
    path: "/fi/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___fr",
    path: "/fr/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___de",
    path: "/de/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___el",
    path: "/el/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___hu",
    path: "/hu/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___ga",
    path: "/ga/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___it",
    path: "/it/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___lv",
    path: "/lv/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___lt",
    path: "/lt/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___mt",
    path: "/mt/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___pl",
    path: "/pl/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___pt",
    path: "/pt/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___ro",
    path: "/ro/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___sk",
    path: "/sk/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___sl",
    path: "/sl/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___es",
    path: "/es/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___sv",
    path: "/sv/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___tr",
    path: "/tr/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___my",
    path: "/my/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___fil",
    path: "/fil/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___ro-md",
    path: "/ro-md/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___dv",
    path: "/dv/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___hy",
    path: "/hy/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___sq",
    path: "/sq/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___bs",
    path: "/bs/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___sr",
    path: "/sr/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___ka",
    path: "/ka/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___ne",
    path: "/ne/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___vi",
    path: "/vi/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___ko",
    path: "/ko/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "viber-otp___he",
    path: "/he/viber-otp",
    component: () => import("/builds/sbt/smsbat/pages/viber-otp/index.vue")
  },
  {
    name: "partnership___en-us",
    path: "/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___uk-ua",
    path: "/uk-ua/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___bg",
    path: "/bg/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___hr",
    path: "/hr/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___cs",
    path: "/cs/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___da",
    path: "/da/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___nl",
    path: "/nl/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___et",
    path: "/et/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___fi",
    path: "/fi/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___fr",
    path: "/fr/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___de",
    path: "/de/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___el",
    path: "/el/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___hu",
    path: "/hu/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___ga",
    path: "/ga/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___it",
    path: "/it/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___lv",
    path: "/lv/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___lt",
    path: "/lt/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___mt",
    path: "/mt/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___pl",
    path: "/pl/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___pt",
    path: "/pt/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___ro",
    path: "/ro/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___sk",
    path: "/sk/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___sl",
    path: "/sl/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___es",
    path: "/es/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___sv",
    path: "/sv/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___tr",
    path: "/tr/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___my",
    path: "/my/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___fil",
    path: "/fil/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___ro-md",
    path: "/ro-md/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___dv",
    path: "/dv/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___hy",
    path: "/hy/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___sq",
    path: "/sq/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___bs",
    path: "/bs/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___sr",
    path: "/sr/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___ka",
    path: "/ka/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___ne",
    path: "/ne/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___vi",
    path: "/vi/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___ko",
    path: "/ko/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "partnership___he",
    path: "/he/partnership",
    component: () => import("/builds/sbt/smsbat/pages/partnership/index.vue")
  },
  {
    name: "sms-gateway___en-us",
    path: "/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___uk-ua",
    path: "/uk-ua/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___bg",
    path: "/bg/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___hr",
    path: "/hr/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___cs",
    path: "/cs/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___da",
    path: "/da/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___nl",
    path: "/nl/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___et",
    path: "/et/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___fi",
    path: "/fi/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___fr",
    path: "/fr/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___de",
    path: "/de/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___el",
    path: "/el/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___hu",
    path: "/hu/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___ga",
    path: "/ga/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___it",
    path: "/it/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___lv",
    path: "/lv/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___lt",
    path: "/lt/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___mt",
    path: "/mt/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___pl",
    path: "/pl/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___pt",
    path: "/pt/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___ro",
    path: "/ro/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___sk",
    path: "/sk/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___sl",
    path: "/sl/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___es",
    path: "/es/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___sv",
    path: "/sv/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___tr",
    path: "/tr/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___my",
    path: "/my/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___fil",
    path: "/fil/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___ro-md",
    path: "/ro-md/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___dv",
    path: "/dv/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___hy",
    path: "/hy/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___sq",
    path: "/sq/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___bs",
    path: "/bs/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___sr",
    path: "/sr/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___ka",
    path: "/ka/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___ne",
    path: "/ne/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___vi",
    path: "/vi/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___ko",
    path: "/ko/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "sms-gateway___he",
    path: "/he/sms-gateway",
    component: () => import("/builds/sbt/smsbat/pages/sms-gateway/index.vue")
  },
  {
    name: "certificates___en-us",
    path: "/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___uk-ua",
    path: "/uk-ua/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___bg",
    path: "/bg/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___hr",
    path: "/hr/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___cs",
    path: "/cs/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___da",
    path: "/da/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___nl",
    path: "/nl/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___et",
    path: "/et/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___fi",
    path: "/fi/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___fr",
    path: "/fr/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___de",
    path: "/de/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___el",
    path: "/el/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___hu",
    path: "/hu/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___ga",
    path: "/ga/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___it",
    path: "/it/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___lv",
    path: "/lv/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___lt",
    path: "/lt/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___mt",
    path: "/mt/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___pl",
    path: "/pl/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___pt",
    path: "/pt/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___ro",
    path: "/ro/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___sk",
    path: "/sk/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___sl",
    path: "/sl/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___es",
    path: "/es/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___sv",
    path: "/sv/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___tr",
    path: "/tr/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___my",
    path: "/my/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___fil",
    path: "/fil/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___ro-md",
    path: "/ro-md/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___dv",
    path: "/dv/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___hy",
    path: "/hy/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___sq",
    path: "/sq/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___bs",
    path: "/bs/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___sr",
    path: "/sr/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___ka",
    path: "/ka/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___ne",
    path: "/ne/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___vi",
    path: "/vi/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___ko",
    path: "/ko/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "certificates___he",
    path: "/he/certificates",
    component: () => import("/builds/sbt/smsbat/pages/certificates/index.vue")
  },
  {
    name: "register-bot___en-us",
    path: "/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___uk-ua",
    path: "/uk-ua/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___bg",
    path: "/bg/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___hr",
    path: "/hr/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___cs",
    path: "/cs/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___da",
    path: "/da/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___nl",
    path: "/nl/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___et",
    path: "/et/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___fi",
    path: "/fi/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___fr",
    path: "/fr/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___de",
    path: "/de/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___el",
    path: "/el/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___hu",
    path: "/hu/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___ga",
    path: "/ga/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___it",
    path: "/it/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___lv",
    path: "/lv/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___lt",
    path: "/lt/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___mt",
    path: "/mt/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___pl",
    path: "/pl/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___pt",
    path: "/pt/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___ro",
    path: "/ro/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___sk",
    path: "/sk/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___sl",
    path: "/sl/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___es",
    path: "/es/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___sv",
    path: "/sv/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___tr",
    path: "/tr/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___my",
    path: "/my/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___fil",
    path: "/fil/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___ro-md",
    path: "/ro-md/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___dv",
    path: "/dv/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___hy",
    path: "/hy/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___sq",
    path: "/sq/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___bs",
    path: "/bs/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___sr",
    path: "/sr/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___ka",
    path: "/ka/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___ne",
    path: "/ne/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___vi",
    path: "/vi/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___ko",
    path: "/ko/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "register-bot___he",
    path: "/he/register-bot",
    component: () => import("/builds/sbt/smsbat/pages/register-bot/index.vue")
  },
  {
    name: "viber-survey___en-us",
    path: "/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___uk-ua",
    path: "/uk-ua/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___bg",
    path: "/bg/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___hr",
    path: "/hr/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___cs",
    path: "/cs/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___da",
    path: "/da/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___nl",
    path: "/nl/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___et",
    path: "/et/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___fi",
    path: "/fi/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___fr",
    path: "/fr/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___de",
    path: "/de/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___el",
    path: "/el/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___hu",
    path: "/hu/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___ga",
    path: "/ga/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___it",
    path: "/it/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___lv",
    path: "/lv/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___lt",
    path: "/lt/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___mt",
    path: "/mt/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___pl",
    path: "/pl/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___pt",
    path: "/pt/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___ro",
    path: "/ro/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___sk",
    path: "/sk/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___sl",
    path: "/sl/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___es",
    path: "/es/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___sv",
    path: "/sv/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___tr",
    path: "/tr/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___my",
    path: "/my/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___fil",
    path: "/fil/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___ro-md",
    path: "/ro-md/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___dv",
    path: "/dv/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___hy",
    path: "/hy/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___sq",
    path: "/sq/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___bs",
    path: "/bs/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___sr",
    path: "/sr/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___ka",
    path: "/ka/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___ne",
    path: "/ne/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___vi",
    path: "/vi/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___ko",
    path: "/ko/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "viber-survey___he",
    path: "/he/viber-survey",
    component: () => import("/builds/sbt/smsbat/pages/viber-survey/index.vue")
  },
  {
    name: "n8n-ai-agents___en-us",
    path: "/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___uk-ua",
    path: "/uk-ua/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___bg",
    path: "/bg/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___hr",
    path: "/hr/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___cs",
    path: "/cs/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___da",
    path: "/da/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___nl",
    path: "/nl/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___et",
    path: "/et/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___fi",
    path: "/fi/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___fr",
    path: "/fr/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___de",
    path: "/de/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___el",
    path: "/el/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___hu",
    path: "/hu/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___ga",
    path: "/ga/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___it",
    path: "/it/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___lv",
    path: "/lv/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___lt",
    path: "/lt/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___mt",
    path: "/mt/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___pl",
    path: "/pl/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___pt",
    path: "/pt/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___ro",
    path: "/ro/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___sk",
    path: "/sk/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___sl",
    path: "/sl/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___es",
    path: "/es/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___sv",
    path: "/sv/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___tr",
    path: "/tr/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___my",
    path: "/my/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___fil",
    path: "/fil/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___ro-md",
    path: "/ro-md/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___dv",
    path: "/dv/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___hy",
    path: "/hy/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___sq",
    path: "/sq/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___bs",
    path: "/bs/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___sr",
    path: "/sr/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___ka",
    path: "/ka/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___ne",
    path: "/ne/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___vi",
    path: "/vi/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___ko",
    path: "/ko/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "n8n-ai-agents___he",
    path: "/he/n8n-ai-agents",
    component: () => import("/builds/sbt/smsbat/pages/n8n-ai-agents/index.vue")
  },
  {
    name: "sms-marketing___en-us",
    path: "/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___uk-ua",
    path: "/uk-ua/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___bg",
    path: "/bg/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___hr",
    path: "/hr/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___cs",
    path: "/cs/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___da",
    path: "/da/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___nl",
    path: "/nl/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___et",
    path: "/et/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___fi",
    path: "/fi/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___fr",
    path: "/fr/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___de",
    path: "/de/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___el",
    path: "/el/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___hu",
    path: "/hu/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___ga",
    path: "/ga/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___it",
    path: "/it/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___lv",
    path: "/lv/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___lt",
    path: "/lt/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___mt",
    path: "/mt/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___pl",
    path: "/pl/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___pt",
    path: "/pt/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___ro",
    path: "/ro/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___sk",
    path: "/sk/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___sl",
    path: "/sl/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___es",
    path: "/es/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___sv",
    path: "/sv/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___tr",
    path: "/tr/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___my",
    path: "/my/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___fil",
    path: "/fil/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___ro-md",
    path: "/ro-md/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___dv",
    path: "/dv/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___hy",
    path: "/hy/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___sq",
    path: "/sq/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___bs",
    path: "/bs/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___sr",
    path: "/sr/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___ka",
    path: "/ka/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___ne",
    path: "/ne/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___vi",
    path: "/vi/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___ko",
    path: "/ko/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "sms-marketing___he",
    path: "/he/sms-marketing",
    component: () => import("/builds/sbt/smsbat/pages/sms-marketing/index.vue")
  },
  {
    name: "viber-carousel___en-us",
    path: "/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___uk-ua",
    path: "/uk-ua/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___bg",
    path: "/bg/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___hr",
    path: "/hr/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___cs",
    path: "/cs/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___da",
    path: "/da/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___nl",
    path: "/nl/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___et",
    path: "/et/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___fi",
    path: "/fi/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___fr",
    path: "/fr/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___de",
    path: "/de/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___el",
    path: "/el/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___hu",
    path: "/hu/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___ga",
    path: "/ga/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___it",
    path: "/it/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___lv",
    path: "/lv/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___lt",
    path: "/lt/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___mt",
    path: "/mt/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___pl",
    path: "/pl/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___pt",
    path: "/pt/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___ro",
    path: "/ro/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___sk",
    path: "/sk/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___sl",
    path: "/sl/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___es",
    path: "/es/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___sv",
    path: "/sv/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___tr",
    path: "/tr/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___my",
    path: "/my/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___fil",
    path: "/fil/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___ro-md",
    path: "/ro-md/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___dv",
    path: "/dv/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___hy",
    path: "/hy/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___sq",
    path: "/sq/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___bs",
    path: "/bs/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___sr",
    path: "/sr/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___ka",
    path: "/ka/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___ne",
    path: "/ne/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___vi",
    path: "/vi/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___ko",
    path: "/ko/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-carousel___he",
    path: "/he/viber-carousel",
    component: () => import("/builds/sbt/smsbat/pages/viber-carousel/index.vue")
  },
  {
    name: "viber-chatbots___en-us",
    path: "/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___uk-ua",
    path: "/uk-ua/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___bg",
    path: "/bg/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___hr",
    path: "/hr/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___cs",
    path: "/cs/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___da",
    path: "/da/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___nl",
    path: "/nl/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___et",
    path: "/et/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___fi",
    path: "/fi/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___fr",
    path: "/fr/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___de",
    path: "/de/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___el",
    path: "/el/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___hu",
    path: "/hu/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___ga",
    path: "/ga/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___it",
    path: "/it/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___lv",
    path: "/lv/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___lt",
    path: "/lt/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___mt",
    path: "/mt/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___pl",
    path: "/pl/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___pt",
    path: "/pt/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___ro",
    path: "/ro/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___sk",
    path: "/sk/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___sl",
    path: "/sl/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___es",
    path: "/es/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___sv",
    path: "/sv/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___tr",
    path: "/tr/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___my",
    path: "/my/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___fil",
    path: "/fil/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___ro-md",
    path: "/ro-md/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___dv",
    path: "/dv/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___hy",
    path: "/hy/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___sq",
    path: "/sq/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___bs",
    path: "/bs/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___sr",
    path: "/sr/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___ka",
    path: "/ka/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___ne",
    path: "/ne/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___vi",
    path: "/vi/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___ko",
    path: "/ko/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "viber-chatbots___he",
    path: "/he/viber-chatbots",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbots/index.vue")
  },
  {
    name: "session-counter___en-us",
    path: "/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___uk-ua",
    path: "/uk-ua/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___bg",
    path: "/bg/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___hr",
    path: "/hr/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___cs",
    path: "/cs/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___da",
    path: "/da/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___nl",
    path: "/nl/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___et",
    path: "/et/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___fi",
    path: "/fi/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___fr",
    path: "/fr/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___de",
    path: "/de/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___el",
    path: "/el/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___hu",
    path: "/hu/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___ga",
    path: "/ga/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___it",
    path: "/it/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___lv",
    path: "/lv/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___lt",
    path: "/lt/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___mt",
    path: "/mt/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___pl",
    path: "/pl/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___pt",
    path: "/pt/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___ro",
    path: "/ro/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___sk",
    path: "/sk/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___sl",
    path: "/sl/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___es",
    path: "/es/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___sv",
    path: "/sv/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___tr",
    path: "/tr/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___my",
    path: "/my/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___fil",
    path: "/fil/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___ro-md",
    path: "/ro-md/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___dv",
    path: "/dv/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___hy",
    path: "/hy/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___sq",
    path: "/sq/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___bs",
    path: "/bs/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___sr",
    path: "/sr/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___ka",
    path: "/ka/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___ne",
    path: "/ne/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___vi",
    path: "/vi/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___ko",
    path: "/ko/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "session-counter___he",
    path: "/he/session-counter",
    component: () => import("/builds/sbt/smsbat/pages/session-counter/index.vue")
  },
  {
    name: "bots-constructor___en-us",
    path: "/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___uk-ua",
    path: "/uk-ua/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___bg",
    path: "/bg/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___hr",
    path: "/hr/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___cs",
    path: "/cs/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___da",
    path: "/da/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___nl",
    path: "/nl/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___et",
    path: "/et/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___fi",
    path: "/fi/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___fr",
    path: "/fr/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___de",
    path: "/de/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___el",
    path: "/el/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___hu",
    path: "/hu/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___ga",
    path: "/ga/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___it",
    path: "/it/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___lv",
    path: "/lv/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___lt",
    path: "/lt/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___mt",
    path: "/mt/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___pl",
    path: "/pl/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___pt",
    path: "/pt/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___ro",
    path: "/ro/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___sk",
    path: "/sk/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___sl",
    path: "/sl/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___es",
    path: "/es/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___sv",
    path: "/sv/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___tr",
    path: "/tr/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___my",
    path: "/my/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___fil",
    path: "/fil/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___ro-md",
    path: "/ro-md/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___dv",
    path: "/dv/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___hy",
    path: "/hy/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___sq",
    path: "/sq/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___bs",
    path: "/bs/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___sr",
    path: "/sr/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___ka",
    path: "/ka/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___ne",
    path: "/ne/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___vi",
    path: "/vi/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___ko",
    path: "/ko/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "bots-constructor___he",
    path: "/he/bots-constructor",
    component: () => import("/builds/sbt/smsbat/pages/bots-constructor/index.vue")
  },
  {
    name: "how-it-works-rcs___en-us",
    path: "/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___uk-ua",
    path: "/uk-ua/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___bg",
    path: "/bg/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___hr",
    path: "/hr/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___cs",
    path: "/cs/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___da",
    path: "/da/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___nl",
    path: "/nl/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___et",
    path: "/et/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___fi",
    path: "/fi/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___fr",
    path: "/fr/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___de",
    path: "/de/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___el",
    path: "/el/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___hu",
    path: "/hu/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___ga",
    path: "/ga/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___it",
    path: "/it/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___lv",
    path: "/lv/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___lt",
    path: "/lt/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___mt",
    path: "/mt/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___pl",
    path: "/pl/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___pt",
    path: "/pt/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___ro",
    path: "/ro/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___sk",
    path: "/sk/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___sl",
    path: "/sl/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___es",
    path: "/es/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___sv",
    path: "/sv/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___tr",
    path: "/tr/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___my",
    path: "/my/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___fil",
    path: "/fil/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___ro-md",
    path: "/ro-md/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___dv",
    path: "/dv/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___hy",
    path: "/hy/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___sq",
    path: "/sq/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___bs",
    path: "/bs/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___sr",
    path: "/sr/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___ka",
    path: "/ka/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___ne",
    path: "/ne/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___vi",
    path: "/vi/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___ko",
    path: "/ko/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-rcs___he",
    path: "/he/how-it-works/rcs",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/rcs/index.vue")
  },
  {
    name: "how-it-works-sms___en-us",
    path: "/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___uk-ua",
    path: "/uk-ua/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___bg",
    path: "/bg/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___hr",
    path: "/hr/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___cs",
    path: "/cs/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___da",
    path: "/da/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___nl",
    path: "/nl/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___et",
    path: "/et/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___fi",
    path: "/fi/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___fr",
    path: "/fr/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___de",
    path: "/de/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___el",
    path: "/el/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___hu",
    path: "/hu/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___ga",
    path: "/ga/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___it",
    path: "/it/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___lv",
    path: "/lv/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___lt",
    path: "/lt/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___mt",
    path: "/mt/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___pl",
    path: "/pl/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___pt",
    path: "/pt/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___ro",
    path: "/ro/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___sk",
    path: "/sk/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___sl",
    path: "/sl/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___es",
    path: "/es/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___sv",
    path: "/sv/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___tr",
    path: "/tr/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___my",
    path: "/my/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___fil",
    path: "/fil/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___ro-md",
    path: "/ro-md/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___dv",
    path: "/dv/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___hy",
    path: "/hy/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___sq",
    path: "/sq/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___bs",
    path: "/bs/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___sr",
    path: "/sr/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___ka",
    path: "/ka/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___ne",
    path: "/ne/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___vi",
    path: "/vi/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___ko",
    path: "/ko/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "how-it-works-sms___he",
    path: "/he/how-it-works/sms",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/sms/index.vue")
  },
  {
    name: "pricing-channel___en-us",
    path: "/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___uk-ua",
    path: "/uk-ua/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___bg",
    path: "/bg/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___hr",
    path: "/hr/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___cs",
    path: "/cs/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___da",
    path: "/da/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___nl",
    path: "/nl/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___et",
    path: "/et/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___fi",
    path: "/fi/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___fr",
    path: "/fr/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___de",
    path: "/de/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___el",
    path: "/el/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___hu",
    path: "/hu/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___ga",
    path: "/ga/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___it",
    path: "/it/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___lv",
    path: "/lv/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___lt",
    path: "/lt/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___mt",
    path: "/mt/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___pl",
    path: "/pl/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___pt",
    path: "/pt/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___ro",
    path: "/ro/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___sk",
    path: "/sk/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___sl",
    path: "/sl/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___es",
    path: "/es/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___sv",
    path: "/sv/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___tr",
    path: "/tr/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___my",
    path: "/my/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___fil",
    path: "/fil/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___ro-md",
    path: "/ro-md/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___dv",
    path: "/dv/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___hy",
    path: "/hy/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___sq",
    path: "/sq/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___bs",
    path: "/bs/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___sr",
    path: "/sr/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___ka",
    path: "/ka/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___ne",
    path: "/ne/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___vi",
    path: "/vi/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___ko",
    path: "/ko/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "pricing-channel___he",
    path: "/he/pricing/:channel()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/index.vue")
  },
  {
    name: "viber-chatbot-api___en-us",
    path: "/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___uk-ua",
    path: "/uk-ua/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___bg",
    path: "/bg/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___hr",
    path: "/hr/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___cs",
    path: "/cs/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___da",
    path: "/da/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___nl",
    path: "/nl/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___et",
    path: "/et/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___fi",
    path: "/fi/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___fr",
    path: "/fr/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___de",
    path: "/de/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___el",
    path: "/el/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___hu",
    path: "/hu/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___ga",
    path: "/ga/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___it",
    path: "/it/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___lv",
    path: "/lv/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___lt",
    path: "/lt/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___mt",
    path: "/mt/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___pl",
    path: "/pl/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___pt",
    path: "/pt/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___ro",
    path: "/ro/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___sk",
    path: "/sk/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___sl",
    path: "/sl/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___es",
    path: "/es/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___sv",
    path: "/sv/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___tr",
    path: "/tr/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___my",
    path: "/my/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___fil",
    path: "/fil/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___ro-md",
    path: "/ro-md/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___dv",
    path: "/dv/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___hy",
    path: "/hy/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___sq",
    path: "/sq/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___bs",
    path: "/bs/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___sr",
    path: "/sr/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___ka",
    path: "/ka/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___ne",
    path: "/ne/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___vi",
    path: "/vi/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___ko",
    path: "/ko/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "viber-chatbot-api___he",
    path: "/he/viber-chatbot-api",
    component: () => import("/builds/sbt/smsbat/pages/viber-chatbot-api/index.vue")
  },
  {
    name: "how-it-works-viber___en-us",
    path: "/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___uk-ua",
    path: "/uk-ua/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___bg",
    path: "/bg/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___hr",
    path: "/hr/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___cs",
    path: "/cs/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___da",
    path: "/da/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___nl",
    path: "/nl/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___et",
    path: "/et/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___fi",
    path: "/fi/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___fr",
    path: "/fr/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___de",
    path: "/de/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___el",
    path: "/el/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___hu",
    path: "/hu/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___ga",
    path: "/ga/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___it",
    path: "/it/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___lv",
    path: "/lv/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___lt",
    path: "/lt/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___mt",
    path: "/mt/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___pl",
    path: "/pl/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___pt",
    path: "/pt/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___ro",
    path: "/ro/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___sk",
    path: "/sk/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___sl",
    path: "/sl/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___es",
    path: "/es/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___sv",
    path: "/sv/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___tr",
    path: "/tr/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___my",
    path: "/my/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___fil",
    path: "/fil/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___ro-md",
    path: "/ro-md/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___dv",
    path: "/dv/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___hy",
    path: "/hy/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___sq",
    path: "/sq/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___bs",
    path: "/bs/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___sr",
    path: "/sr/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___ka",
    path: "/ka/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___ne",
    path: "/ne/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___vi",
    path: "/vi/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___ko",
    path: "/ko/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "how-it-works-viber___he",
    path: "/he/how-it-works/viber",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/viber/index.vue")
  },
  {
    name: "viber-bot-provider___en-us",
    path: "/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___uk-ua",
    path: "/uk-ua/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___bg",
    path: "/bg/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___hr",
    path: "/hr/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___cs",
    path: "/cs/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___da",
    path: "/da/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___nl",
    path: "/nl/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___et",
    path: "/et/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___fi",
    path: "/fi/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___fr",
    path: "/fr/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___de",
    path: "/de/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___el",
    path: "/el/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___hu",
    path: "/hu/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___ga",
    path: "/ga/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___it",
    path: "/it/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___lv",
    path: "/lv/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___lt",
    path: "/lt/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___mt",
    path: "/mt/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___pl",
    path: "/pl/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___pt",
    path: "/pt/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___ro",
    path: "/ro/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___sk",
    path: "/sk/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___sl",
    path: "/sl/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___es",
    path: "/es/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___sv",
    path: "/sv/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___tr",
    path: "/tr/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___my",
    path: "/my/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___fil",
    path: "/fil/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___ro-md",
    path: "/ro-md/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___dv",
    path: "/dv/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___hy",
    path: "/hy/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___sq",
    path: "/sq/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___bs",
    path: "/bs/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___sr",
    path: "/sr/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___ka",
    path: "/ka/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___ne",
    path: "/ne/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___vi",
    path: "/vi/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___ko",
    path: "/ko/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-provider___he",
    path: "/he/viber-bot-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-provider/index.vue")
  },
  {
    name: "viber-bot-promotion___en-us",
    path: "/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___uk-ua",
    path: "/uk-ua/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___bg",
    path: "/bg/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___hr",
    path: "/hr/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___cs",
    path: "/cs/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___da",
    path: "/da/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___nl",
    path: "/nl/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___et",
    path: "/et/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___fi",
    path: "/fi/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___fr",
    path: "/fr/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___de",
    path: "/de/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___el",
    path: "/el/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___hu",
    path: "/hu/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___ga",
    path: "/ga/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___it",
    path: "/it/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___lv",
    path: "/lv/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___lt",
    path: "/lt/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___mt",
    path: "/mt/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___pl",
    path: "/pl/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___pt",
    path: "/pt/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___ro",
    path: "/ro/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___sk",
    path: "/sk/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___sl",
    path: "/sl/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___es",
    path: "/es/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___sv",
    path: "/sv/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___tr",
    path: "/tr/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___my",
    path: "/my/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___fil",
    path: "/fil/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___ro-md",
    path: "/ro-md/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___dv",
    path: "/dv/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___hy",
    path: "/hy/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___sq",
    path: "/sq/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___bs",
    path: "/bs/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___sr",
    path: "/sr/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___ka",
    path: "/ka/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___ne",
    path: "/ne/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___vi",
    path: "/vi/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___ko",
    path: "/ko/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-bot-promotion___he",
    path: "/he/viber-bot-promotion",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-promotion/index.vue")
  },
  {
    name: "viber-chat-sessions___en-us",
    path: "/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___uk-ua",
    path: "/uk-ua/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___bg",
    path: "/bg/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___hr",
    path: "/hr/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___cs",
    path: "/cs/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___da",
    path: "/da/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___nl",
    path: "/nl/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___et",
    path: "/et/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___fi",
    path: "/fi/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___fr",
    path: "/fr/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___de",
    path: "/de/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___el",
    path: "/el/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___hu",
    path: "/hu/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___ga",
    path: "/ga/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___it",
    path: "/it/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___lv",
    path: "/lv/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___lt",
    path: "/lt/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___mt",
    path: "/mt/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___pl",
    path: "/pl/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___pt",
    path: "/pt/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___ro",
    path: "/ro/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___sk",
    path: "/sk/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___sl",
    path: "/sl/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___es",
    path: "/es/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___sv",
    path: "/sv/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___tr",
    path: "/tr/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___my",
    path: "/my/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___fil",
    path: "/fil/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___ro-md",
    path: "/ro-md/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___dv",
    path: "/dv/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___hy",
    path: "/hy/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___sq",
    path: "/sq/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___bs",
    path: "/bs/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___sr",
    path: "/sr/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___ka",
    path: "/ka/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___ne",
    path: "/ne/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___vi",
    path: "/vi/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___ko",
    path: "/ko/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-chat-sessions___he",
    path: "/he/viber-chat-sessions",
    component: () => import("/builds/sbt/smsbat/pages/viber-chat-sessions/index.vue")
  },
  {
    name: "viber-business-calls___en-us",
    path: "/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___uk-ua",
    path: "/uk-ua/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___bg",
    path: "/bg/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___hr",
    path: "/hr/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___cs",
    path: "/cs/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___da",
    path: "/da/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___nl",
    path: "/nl/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___et",
    path: "/et/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___fi",
    path: "/fi/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___fr",
    path: "/fr/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___de",
    path: "/de/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___el",
    path: "/el/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___hu",
    path: "/hu/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___ga",
    path: "/ga/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___it",
    path: "/it/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___lv",
    path: "/lv/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___lt",
    path: "/lt/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___mt",
    path: "/mt/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___pl",
    path: "/pl/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___pt",
    path: "/pt/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___ro",
    path: "/ro/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___sk",
    path: "/sk/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___sl",
    path: "/sl/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___es",
    path: "/es/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___sv",
    path: "/sv/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___tr",
    path: "/tr/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___my",
    path: "/my/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___fil",
    path: "/fil/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___ro-md",
    path: "/ro-md/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___dv",
    path: "/dv/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___hy",
    path: "/hy/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___sq",
    path: "/sq/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___bs",
    path: "/bs/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___sr",
    path: "/sr/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___ka",
    path: "/ka/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___ne",
    path: "/ne/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___vi",
    path: "/vi/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___ko",
    path: "/ko/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "viber-business-calls___he",
    path: "/he/viber-business-calls",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls/index.vue")
  },
  {
    name: "how-it-works-whatsapp___en-us",
    path: "/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___uk-ua",
    path: "/uk-ua/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___bg",
    path: "/bg/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___hr",
    path: "/hr/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___cs",
    path: "/cs/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___da",
    path: "/da/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___nl",
    path: "/nl/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___et",
    path: "/et/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___fi",
    path: "/fi/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___fr",
    path: "/fr/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___de",
    path: "/de/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___el",
    path: "/el/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___hu",
    path: "/hu/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___ga",
    path: "/ga/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___it",
    path: "/it/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___lv",
    path: "/lv/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___lt",
    path: "/lt/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___mt",
    path: "/mt/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___pl",
    path: "/pl/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___pt",
    path: "/pt/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___ro",
    path: "/ro/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___sk",
    path: "/sk/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___sl",
    path: "/sl/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___es",
    path: "/es/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___sv",
    path: "/sv/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___tr",
    path: "/tr/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___my",
    path: "/my/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___fil",
    path: "/fil/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___ro-md",
    path: "/ro-md/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___dv",
    path: "/dv/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___hy",
    path: "/hy/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___sq",
    path: "/sq/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___bs",
    path: "/bs/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___sr",
    path: "/sr/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___ka",
    path: "/ka/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___ne",
    path: "/ne/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___vi",
    path: "/vi/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___ko",
    path: "/ko/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "how-it-works-whatsapp___he",
    path: "/he/how-it-works/whatsapp",
    component: () => import("/builds/sbt/smsbat/pages/how-it-works/whatsapp/index.vue")
  },
  {
    name: "viber-bot-registration___en-us",
    path: "/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___uk-ua",
    path: "/uk-ua/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___bg",
    path: "/bg/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___hr",
    path: "/hr/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___cs",
    path: "/cs/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___da",
    path: "/da/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___nl",
    path: "/nl/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___et",
    path: "/et/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___fi",
    path: "/fi/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___fr",
    path: "/fr/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___de",
    path: "/de/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___el",
    path: "/el/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___hu",
    path: "/hu/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___ga",
    path: "/ga/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___it",
    path: "/it/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___lv",
    path: "/lv/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___lt",
    path: "/lt/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___mt",
    path: "/mt/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___pl",
    path: "/pl/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___pt",
    path: "/pt/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___ro",
    path: "/ro/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___sk",
    path: "/sk/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___sl",
    path: "/sl/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___es",
    path: "/es/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___sv",
    path: "/sv/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___tr",
    path: "/tr/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___my",
    path: "/my/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___fil",
    path: "/fil/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___ro-md",
    path: "/ro-md/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___dv",
    path: "/dv/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___hy",
    path: "/hy/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___sq",
    path: "/sq/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___bs",
    path: "/bs/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___sr",
    path: "/sr/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___ka",
    path: "/ka/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___ne",
    path: "/ne/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___vi",
    path: "/vi/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___ko",
    path: "/ko/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-registration___he",
    path: "/he/viber-bot-registration",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-registration/index.vue")
  },
  {
    name: "viber-bot-verification___en-us",
    path: "/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___uk-ua",
    path: "/uk-ua/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___bg",
    path: "/bg/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___hr",
    path: "/hr/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___cs",
    path: "/cs/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___da",
    path: "/da/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___nl",
    path: "/nl/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___et",
    path: "/et/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___fi",
    path: "/fi/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___fr",
    path: "/fr/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___de",
    path: "/de/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___el",
    path: "/el/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___hu",
    path: "/hu/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___ga",
    path: "/ga/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___it",
    path: "/it/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___lv",
    path: "/lv/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___lt",
    path: "/lt/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___mt",
    path: "/mt/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___pl",
    path: "/pl/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___pt",
    path: "/pt/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___ro",
    path: "/ro/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___sk",
    path: "/sk/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___sl",
    path: "/sl/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___es",
    path: "/es/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___sv",
    path: "/sv/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___tr",
    path: "/tr/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___my",
    path: "/my/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___fil",
    path: "/fil/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___ro-md",
    path: "/ro-md/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___dv",
    path: "/dv/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___hy",
    path: "/hy/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___sq",
    path: "/sq/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___bs",
    path: "/bs/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___sr",
    path: "/sr/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___ka",
    path: "/ka/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___ne",
    path: "/ne/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___vi",
    path: "/vi/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___ko",
    path: "/ko/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "viber-bot-verification___he",
    path: "/he/viber-bot-verification",
    component: () => import("/builds/sbt/smsbat/pages/viber-bot-verification/index.vue")
  },
  {
    name: "sms-alert-notifications___en-us",
    path: "/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___uk-ua",
    path: "/uk-ua/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___bg",
    path: "/bg/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___hr",
    path: "/hr/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___cs",
    path: "/cs/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___da",
    path: "/da/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___nl",
    path: "/nl/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___et",
    path: "/et/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___fi",
    path: "/fi/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___fr",
    path: "/fr/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___de",
    path: "/de/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___el",
    path: "/el/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___hu",
    path: "/hu/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___ga",
    path: "/ga/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___it",
    path: "/it/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___lv",
    path: "/lv/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___lt",
    path: "/lt/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___mt",
    path: "/mt/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___pl",
    path: "/pl/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___pt",
    path: "/pt/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___ro",
    path: "/ro/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___sk",
    path: "/sk/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___sl",
    path: "/sl/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___es",
    path: "/es/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___sv",
    path: "/sv/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___tr",
    path: "/tr/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___my",
    path: "/my/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___fil",
    path: "/fil/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___ro-md",
    path: "/ro-md/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___dv",
    path: "/dv/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___hy",
    path: "/hy/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___sq",
    path: "/sq/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___bs",
    path: "/bs/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___sr",
    path: "/sr/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___ka",
    path: "/ka/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___ne",
    path: "/ne/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___vi",
    path: "/vi/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___ko",
    path: "/ko/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "sms-alert-notifications___he",
    path: "/he/sms-alert-notifications",
    component: () => import("/builds/sbt/smsbat/pages/sms-alert-notifications/index.vue")
  },
  {
    name: "viber-business-messages___en-us",
    path: "/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___uk-ua",
    path: "/uk-ua/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___bg",
    path: "/bg/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___hr",
    path: "/hr/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___cs",
    path: "/cs/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___da",
    path: "/da/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___nl",
    path: "/nl/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___et",
    path: "/et/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___fi",
    path: "/fi/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___fr",
    path: "/fr/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___de",
    path: "/de/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___el",
    path: "/el/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___hu",
    path: "/hu/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___ga",
    path: "/ga/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___it",
    path: "/it/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___lv",
    path: "/lv/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___lt",
    path: "/lt/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___mt",
    path: "/mt/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___pl",
    path: "/pl/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___pt",
    path: "/pt/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___ro",
    path: "/ro/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___sk",
    path: "/sk/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___sl",
    path: "/sl/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___es",
    path: "/es/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___sv",
    path: "/sv/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___tr",
    path: "/tr/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___my",
    path: "/my/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___fil",
    path: "/fil/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___ro-md",
    path: "/ro-md/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___dv",
    path: "/dv/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___hy",
    path: "/hy/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___sq",
    path: "/sq/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___bs",
    path: "/bs/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___sr",
    path: "/sr/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___ka",
    path: "/ka/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___ne",
    path: "/ne/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___vi",
    path: "/vi/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___ko",
    path: "/ko/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "viber-business-messages___he",
    path: "/he/viber-business-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages/index.vue")
  },
  {
    name: "two-factor-authentication___en-us",
    path: "/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___uk-ua",
    path: "/uk-ua/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___bg",
    path: "/bg/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___hr",
    path: "/hr/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___cs",
    path: "/cs/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___da",
    path: "/da/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___nl",
    path: "/nl/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___et",
    path: "/et/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___fi",
    path: "/fi/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___fr",
    path: "/fr/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___de",
    path: "/de/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___el",
    path: "/el/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___hu",
    path: "/hu/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___ga",
    path: "/ga/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___it",
    path: "/it/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___lv",
    path: "/lv/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___lt",
    path: "/lt/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___mt",
    path: "/mt/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___pl",
    path: "/pl/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___pt",
    path: "/pt/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___ro",
    path: "/ro/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___sk",
    path: "/sk/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___sl",
    path: "/sl/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___es",
    path: "/es/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___sv",
    path: "/sv/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___tr",
    path: "/tr/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___my",
    path: "/my/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___fil",
    path: "/fil/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___ro-md",
    path: "/ro-md/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___dv",
    path: "/dv/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___hy",
    path: "/hy/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___sq",
    path: "/sq/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___bs",
    path: "/bs/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___sr",
    path: "/sr/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___ka",
    path: "/ka/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___ne",
    path: "/ne/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___vi",
    path: "/vi/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___ko",
    path: "/ko/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "two-factor-authentication___he",
    path: "/he/two-factor-authentication",
    component: () => import("/builds/sbt/smsbat/pages/two-factor-authentication/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___en-us",
    path: "/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___uk-ua",
    path: "/uk-ua/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___bg",
    path: "/bg/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___hr",
    path: "/hr/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___cs",
    path: "/cs/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___da",
    path: "/da/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___nl",
    path: "/nl/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___et",
    path: "/et/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___fi",
    path: "/fi/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___fr",
    path: "/fr/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___de",
    path: "/de/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___el",
    path: "/el/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___hu",
    path: "/hu/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___ga",
    path: "/ga/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___it",
    path: "/it/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___lv",
    path: "/lv/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___lt",
    path: "/lt/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___mt",
    path: "/mt/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___pl",
    path: "/pl/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___pt",
    path: "/pt/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___ro",
    path: "/ro/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___sk",
    path: "/sk/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___sl",
    path: "/sl/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___es",
    path: "/es/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___sv",
    path: "/sv/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___tr",
    path: "/tr/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___my",
    path: "/my/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___fil",
    path: "/fil/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___ro-md",
    path: "/ro-md/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___dv",
    path: "/dv/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___hy",
    path: "/hy/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___sq",
    path: "/sq/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___bs",
    path: "/bs/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___sr",
    path: "/sr/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___ka",
    path: "/ka/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___ne",
    path: "/ne/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___vi",
    path: "/vi/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___ko",
    path: "/ko/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "smsbat-cascade-restful-api___he",
    path: "/he/smsbat-cascade-restful-api",
    component: () => import("/builds/sbt/smsbat/pages/smsbat-cascade-restful-api/index.vue")
  },
  {
    name: "pricing-channel-country___en-us",
    path: "/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___uk-ua",
    path: "/uk-ua/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___bg",
    path: "/bg/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___hr",
    path: "/hr/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___cs",
    path: "/cs/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___da",
    path: "/da/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___nl",
    path: "/nl/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___et",
    path: "/et/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___fi",
    path: "/fi/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___fr",
    path: "/fr/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___de",
    path: "/de/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___el",
    path: "/el/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___hu",
    path: "/hu/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___ga",
    path: "/ga/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___it",
    path: "/it/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___lv",
    path: "/lv/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___lt",
    path: "/lt/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___mt",
    path: "/mt/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___pl",
    path: "/pl/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___pt",
    path: "/pt/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___ro",
    path: "/ro/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___sk",
    path: "/sk/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___sl",
    path: "/sl/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___es",
    path: "/es/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___sv",
    path: "/sv/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___tr",
    path: "/tr/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___my",
    path: "/my/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___fil",
    path: "/fil/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___ro-md",
    path: "/ro-md/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___dv",
    path: "/dv/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___hy",
    path: "/hy/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___sq",
    path: "/sq/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___bs",
    path: "/bs/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___sr",
    path: "/sr/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___ka",
    path: "/ka/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___ne",
    path: "/ne/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___vi",
    path: "/vi/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___ko",
    path: "/ko/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "pricing-channel-country___he",
    path: "/he/pricing/:channel()/:country()",
    component: () => import("/builds/sbt/smsbat/pages/pricing/[channel]/[country]/index.vue")
  },
  {
    name: "viber-transactional-messages___en-us",
    path: "/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___uk-ua",
    path: "/uk-ua/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___bg",
    path: "/bg/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___hr",
    path: "/hr/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___cs",
    path: "/cs/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___da",
    path: "/da/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___nl",
    path: "/nl/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___et",
    path: "/et/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___fi",
    path: "/fi/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___fr",
    path: "/fr/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___de",
    path: "/de/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___el",
    path: "/el/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___hu",
    path: "/hu/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___ga",
    path: "/ga/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___it",
    path: "/it/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___lv",
    path: "/lv/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___lt",
    path: "/lt/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___mt",
    path: "/mt/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___pl",
    path: "/pl/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___pt",
    path: "/pt/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___ro",
    path: "/ro/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___sk",
    path: "/sk/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___sl",
    path: "/sl/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___es",
    path: "/es/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___sv",
    path: "/sv/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___tr",
    path: "/tr/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___my",
    path: "/my/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___fil",
    path: "/fil/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___ro-md",
    path: "/ro-md/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___dv",
    path: "/dv/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___hy",
    path: "/hy/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___sq",
    path: "/sq/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___bs",
    path: "/bs/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___sr",
    path: "/sr/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___ka",
    path: "/ka/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___ne",
    path: "/ne/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___vi",
    path: "/vi/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___ko",
    path: "/ko/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-transactional-messages___he",
    path: "/he/viber-transactional-messages",
    component: () => import("/builds/sbt/smsbat/pages/viber-transactional-messages/index.vue")
  },
  {
    name: "viber-business-calls-provider___en-us",
    path: "/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___uk-ua",
    path: "/uk-ua/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___bg",
    path: "/bg/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___hr",
    path: "/hr/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___cs",
    path: "/cs/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___da",
    path: "/da/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___nl",
    path: "/nl/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___et",
    path: "/et/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___fi",
    path: "/fi/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___fr",
    path: "/fr/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___de",
    path: "/de/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___el",
    path: "/el/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___hu",
    path: "/hu/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___ga",
    path: "/ga/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___it",
    path: "/it/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___lv",
    path: "/lv/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___lt",
    path: "/lt/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___mt",
    path: "/mt/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___pl",
    path: "/pl/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___pt",
    path: "/pt/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___ro",
    path: "/ro/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___sk",
    path: "/sk/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___sl",
    path: "/sl/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___es",
    path: "/es/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___sv",
    path: "/sv/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___tr",
    path: "/tr/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___my",
    path: "/my/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___fil",
    path: "/fil/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___ro-md",
    path: "/ro-md/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___dv",
    path: "/dv/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___hy",
    path: "/hy/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___sq",
    path: "/sq/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___bs",
    path: "/bs/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___sr",
    path: "/sr/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___ka",
    path: "/ka/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___ne",
    path: "/ne/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___vi",
    path: "/vi/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___ko",
    path: "/ko/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-calls-provider___he",
    path: "/he/viber-business-calls-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-calls-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___en-us",
    path: "/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___uk-ua",
    path: "/uk-ua/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___bg",
    path: "/bg/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___hr",
    path: "/hr/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___cs",
    path: "/cs/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___da",
    path: "/da/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___nl",
    path: "/nl/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___et",
    path: "/et/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___fi",
    path: "/fi/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___fr",
    path: "/fr/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___de",
    path: "/de/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___el",
    path: "/el/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___hu",
    path: "/hu/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___ga",
    path: "/ga/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___it",
    path: "/it/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___lv",
    path: "/lv/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___lt",
    path: "/lt/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___mt",
    path: "/mt/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___pl",
    path: "/pl/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___pt",
    path: "/pt/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___ro",
    path: "/ro/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___sk",
    path: "/sk/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___sl",
    path: "/sl/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___es",
    path: "/es/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___sv",
    path: "/sv/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___tr",
    path: "/tr/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___my",
    path: "/my/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___fil",
    path: "/fil/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___ro-md",
    path: "/ro-md/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___dv",
    path: "/dv/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___hy",
    path: "/hy/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___sq",
    path: "/sq/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___bs",
    path: "/bs/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___sr",
    path: "/sr/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___ka",
    path: "/ka/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___ne",
    path: "/ne/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___vi",
    path: "/vi/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___ko",
    path: "/ko/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-provider___he",
    path: "/he/viber-business-messages-provider",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-provider/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___en-us",
    path: "/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___uk-ua",
    path: "/uk-ua/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___bg",
    path: "/bg/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___hr",
    path: "/hr/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___cs",
    path: "/cs/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___da",
    path: "/da/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___nl",
    path: "/nl/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___et",
    path: "/et/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___fi",
    path: "/fi/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___fr",
    path: "/fr/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___de",
    path: "/de/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___el",
    path: "/el/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___hu",
    path: "/hu/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___ga",
    path: "/ga/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___it",
    path: "/it/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___lv",
    path: "/lv/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___lt",
    path: "/lt/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___mt",
    path: "/mt/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___pl",
    path: "/pl/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___pt",
    path: "/pt/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___ro",
    path: "/ro/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___sk",
    path: "/sk/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___sl",
    path: "/sl/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___es",
    path: "/es/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___sv",
    path: "/sv/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___tr",
    path: "/tr/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___my",
    path: "/my/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___fil",
    path: "/fil/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___ro-md",
    path: "/ro-md/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___dv",
    path: "/dv/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___hy",
    path: "/hy/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___sq",
    path: "/sq/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___bs",
    path: "/bs/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___sr",
    path: "/sr/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___ka",
    path: "/ka/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___ne",
    path: "/ne/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___vi",
    path: "/vi/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___ko",
    path: "/ko/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: "viber-business-messages-custom-auto-reply___he",
    path: "/he/viber-business-messages-custom-auto-reply",
    component: () => import("/builds/sbt/smsbat/pages/viber-business-messages-custom-auto-reply/index.vue")
  },
  {
    name: component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqowMeta?.name,
    path: "/pricing/viber-chatbots",
    component: component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqow
  },
  {
    name: component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqowMeta?.name,
    path: "/pricing/viber-business-messages",
    component: component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqow
  },
  {
    name: component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqowMeta?.name,
    path: "/pricing/viber-business-calls",
    component: component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqow
  },
  {
    name: component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqowMeta?.name,
    path: "/ua/register-bot",
    component: component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqow
  },
  {
    name: component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqowMeta?.name,
    path: "/ua/viber-chatbots",
    component: component_45stubM78IYN8WnELu_WVpbAI_45fEm4JG94jbW2BhHgvfQXqow
  }
]